import { cn } from '#app/utils/misc.tsx'

export type MetaRow = {
	label: string
	value: string
}

type MetaGridProps = {
	rows: MetaRow[]
	className?: string
}

/**
 * Two-column blueprint label/value table used in hero meta strips.
 * Auto-fits to fill width, collapsing columns on narrow viewports.
 */
export function MetaGrid({ rows, className }: MetaGridProps) {
	return (
		<dl
			className={cn(
				'grid grid-cols-[repeat(auto-fit,minmax(180px,1fr))] gap-6 border-t border-border pt-8',
				className,
			)}
		>
			{rows.map(({ label, value }) => (
				<div key={label} className="flex flex-col gap-2">
					<dt className="eyebrow">{label}</dt>
					<dd className="font-display text-[18px] font-semibold leading-tight">
						{value}
					</dd>
				</div>
			))}
		</dl>
	)
}
